function createCookie(name, limit){
  document.cookie = name+"=true;max-age="+(limit*60)+";path=/;domain=";
}

function createCookieWithValue(name, value, limit){
  document.cookie = name+"="+value+";max-age="+(limit*60)+";path=/;domain=";
}

function getTokenCookie(name){
  return getCookie(name).split("=")[1];
}
initializeUtilsFunctions();
publish(createCookieWithValue,"createCookieWithValue");
publish(getTokenCookie, "getTokenCookie");

function deleteCookie(name){
  document.cookie = name+"=; Max-Age=-99999999;path=/;domain=";
}

function getCookie(name){
  const cookies = document.cookie.split(";");
  let cookieResult = "";
  if (cookies.length){
    cookies.forEach((cookie) => {
      if (cookie.indexOf(name) > -1){
        cookieResult = cookie;
        return true;
      }
    })
  }
  return cookieResult;
}

function createNaturalSearchCookie(){
  if (drupalSettings.search_engines && drupalSettings.search_engines.length){
    const prevPage = document.referrer;
    drupalSettings.search_engines.forEach((searchEngine) => {
      if (prevPage.indexOf(searchEngine) > -1 && !getCookie("naturalSearch")){
        createCookie("naturalSearch", 30);
      }
    })
  }
}

function generateRandomIntegerInRange(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

executeOnce("home-cookie",function(){
  createNaturalSearchCookie();

  if ((!getCookie("_fbc") || getCookie("_fbc").split("=").length == 0)){
    const searchParams = window.location.search;
    if (searchParams) {
      const urlParams = new URLSearchParams(searchParams);
      const fbclid = urlParams.get("fbclid");
      if (fbclid) {
        const fbc = "fb.1."+idEvent+"."+fbclid;
        createCookieWithValue("_fbc", fbc, 50000);
      }
    }
  }

  //fb api
  if (drupalSettings.facebookApiConverter && drupalSettings.facebookApiConverter.facebookTrackingEnabled && drupalSettings.facebookApiConverter.facebookUrlIp && drupalSettings.facebookApiConverter.facebook_pixel_1 && drupalSettings.facebookApiConverter.facebook_pixel_2){
      const fbp = (getCookie("_fbp") && getCookie("_fbp").split("=").length > 1) ? getCookie("_fbp").split("=")[1]:"";
      const fbc = (getCookie("_fbc") && getCookie("_fbc").split("=").length > 1) ? getCookie("_fbc").split("=")[1]:"";
      const idEvent = Date.now();
      const idEventSha = SHA256(""+idEvent);


      if (!getCookie("publicIp") || getCookie("publicIp").split("=").length <= 1){
        jQuery.get(drupalSettings.facebookApiConverter.facebookUrlIp, function(data){
          createCookieWithValue("publicIp", data, 60);
          sendFacebookApiTracking("PageView",drupalSettings.facebookApiConverter.facebook_pixel_1, 1, data, idEventSha, fbc, fbp);
          sendFacebookApiTracking("PageView",drupalSettings.facebookApiConverter.facebook_pixel_2, 2, data, idEventSha, fbc, fbp);
        });
      } else {
        sendFacebookApiTracking("PageView",drupalSettings.facebookApiConverter.facebook_pixel_1, 1, getCookie("publicIp").split("=")[1], idEventSha, fbc, fbp);
        sendFacebookApiTracking("PageView",drupalSettings.facebookApiConverter.facebook_pixel_2, 2, getCookie("publicIp").split("=")[1], idEventSha, fbc, fbp);
      }
  }

  const tfaForm = document.querySelector('[data-drupal-selector="tfa-entry-form"], [data-drupal-selector="user-login-form"]');
  if (tfaForm){
    tfaForm.addEventListener("submit", () => {
      deleteCookie("authToken");
    });
  }
});
